import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/eval/error-expired')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <section className="contwrap">
      <div className="contInner" id="noticeCont">
        <div className="search-no-result ttukttak_search-no-result">
          <p className="desc-01 cont-mt3 txtCenter">
            기간이 만료되어 지금은 볼 수 없는 평가 화면입니다.
            <br />
            평가 내용을 확인하고 싶다면 선생님에게
            <br />
            문의해 주세요.
          </p>
        </div>
      </div>
    </section>
  )
}
